import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { InterfaceStatusModel } from './interfacestatus.model';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';

@Injectable()
export class InterfaceStatusService {
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();
    constructor(private authService: AuthService, private http: Http) { }

    public GetInterfaceStatusList(input?: DataListModel): Observable<IAPIResponse> {
        let getInterfaceStatusUrl = WeGoConfig.API_GET_INTERFACESTATUS_LIST;
        let queryString = this.authService.HandleAPIListInput(input); //+ '&'+this.JQueryHelper.Param(interfaceStatus);
        if (queryString) {
            getInterfaceStatusUrl = getInterfaceStatusUrl + "?" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getInterfaceStatusUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
    public ExportInterfaceStatus(interfaceStatusModel: InterfaceStatusModel, input?: DataListModel): any {
        input.currentPage = 0;
        let interfaceStatusUrl = WeGoConfig.API_GET_EXPORT_INTERFACESTATUS;
        let queryString = this.authService.HandleAPIListInput(input);// + '&'+this.JQueryHelper.Param(interfaceStatusModel);
        if (queryString) {
            interfaceStatusUrl = interfaceStatusUrl + "?" + queryString;
        }
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(interfaceStatusUrl, options);
      }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfacestatus/models/interfacestatus.service.ts